import script from "./HomePromo.vue?vue&type=script&setup=true&lang=js"
export * from "./HomePromo.vue?vue&type=script&setup=true&lang=js"

import "./HomePromo.vue?vue&type=style&index=0&id=58308a3a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-58308a3a"]])

export default __exports__